import { IRegister } from '../../../_models/account/user';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit {
  loading: boolean;
  register: IRegister;
  registerForm: FormGroup;

  constructor(
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.createRegisterForm();
  }

  submit() {
    if (this.registerForm.valid) {
      this.loading = true;
      this.register = Object.assign({}, this.registerForm.value);
      this.authService.register(this.register).subscribe(() => {
        this.router.navigate(['/account/signup-success']);
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
    }
  }

  createRegisterForm() {
    this.registerForm = this.fb.group({
      shalaId: ['', [Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]],
      //shalaId: ['', [Validators.required, Validators.pattern('^[0-9]{11}$')]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password').value === g.get('confirmPassword').value ? null : { 'mismatch': true };
  }
}
